import { FireIconSmall } from 'src/components/Icons/FireIconSmall'

import type { ProductItem } from '../../../types/productItem'
import { LastUnitsFlag } from './LastUnitsFlag'

interface LastUnitForProductCardWrapperProps {
  skuSelected: ProductItem
  fallbackProductId?: string
}

export function LastUnitForProductCardWrapper({
  skuSelected,
  fallbackProductId,
}: LastUnitForProductCardWrapperProps) {
  const {
    sellerDefault: {
      sellerOffer: { lastUnits },
    },
    flags,
  } = skuSelected

  const isNewProduct = flags?.some(
    (flag) => flag.value.toLocaleLowerCase() === 'novidade'
  )

  if (isNewProduct) return null

  const storageProductId =
    skuSelected.productId || fallbackProductId || skuSelected.itemId

  return (
    <LastUnitsFlag
      isLastUnits={lastUnits}
      productId={storageProductId}
      sectionClassName="mb-2 restructure-small-desktop:mb-3 hidden"
      textClassName="!text-font-size-2 !leading-[120%]"
      IconComponent={FireIconSmall}
    />
  )
}
